import React from 'react';
import PropTypes from 'prop-types';
import ArticleRatedFeaturesListItem from '../ArticleRatedFeaturesListItem';
import * as style from './ArticleRatedFeaturesList.module.scss';

/** Product features with features ranked 0 - 5 */
const ArticleRatedFeaturesList = (props) => {
  const { features } = props;

  return (
    <div className={style.list}>
      {features?.map((feature, index) => (
        <ArticleRatedFeaturesListItem
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          text={feature?.featureName}
          score={feature?.featureRating}
          maxScore={5}
        />
      ))}
    </div>
  );
};

ArticleRatedFeaturesList.propTypes = {
  /** Array of features. */
  features: PropTypes.arrayOf(
    PropTypes.shape({
      featureName: PropTypes.string.isRequired,
      featureRating: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default ArticleRatedFeaturesList;
